<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{ title | translate }}</h4>
    <button
        type="button"
        class="close"
        aria-label="Close button"
        aria-describedby="modal-title"
        (click)="activeModal.dismiss()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>{{ message | translate }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn cancel" (click)="activeModal.dismiss()">{{
        "CONFIRM_ALERT_LABEL_CANCEL" | translate
    }}</button>
    <button type="button" ngbAutofocus class="btn save" (click)="activeModal.close()">{{
        "CONFIRM_ALERT_LABEL_OK" | translate
    }}</button>
</div>
